import { cn } from "@utils/tw"
import { ComponentPropsWithoutRef, forwardRef } from "react"
import { Container, Grid } from "./Grid"

// --tw-grid-inner-width and --tw-grid-col-width aren't overridden directly —
// both are already derived from --tw-grid-container/--tw-grid-margin/
// --tw-grid-gutter via calc() at :root (see tailwind-helper/helpers/grid.ts),
// so overriding just the three base vars here is enough for the derived
// ones to recompute automatically. Skipped entirely in wp-admin (Gutenberg
// editor), where the normal per-breakpoint grid values should apply as-is.
const FULL_BLEED = env.admin ? "" : "w-full px-4 md:px-6"

export const ContainerReset = forwardRef<HTMLDivElement, ComponentPropsWithoutRef<typeof Container>>(
  ({ className, children }, ref) => (
    <div ref={ref} className={cn("w-full px-4 md:px-6", className)}>
      {children}
    </div>
  ),
)
ContainerReset.displayName = "ContainerReset"

export const GridReset = forwardRef<HTMLDivElement, ComponentPropsWithoutRef<typeof Grid>>(
  ({ className, ...props }, ref) => <Grid ref={ref} className={cn(FULL_BLEED, className)} {...props} />,
)
GridReset.displayName = "GridReset"
